<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M10.5,792.52c0,5.51-4.47,9.98-9.98,9.98s-10.02-4.47-10.02-9.98c0-2.76,1.13-5.26,2.94-7.07
	c-0.17-0.28-0.27-0.62-0.27-0.97c0-1.05,0.85-1.9,1.9-1.9c0.61,0,1.16,0.29,1.51,0.74c1.21-0.52,2.54-0.81,3.93-0.81
	C6.03,782.5,10.5,787,10.5,792.52z M0.52,783.32c-1.27,0-2.48,0.26-3.58,0.72c0.03,0.14,0.05,0.28,0.05,0.43
	c0,1.05-0.85,1.9-1.9,1.9c-0.41,0-0.78-0.13-1.09-0.34c-1.66,1.66-2.69,3.95-2.69,6.49c0,5.08,4.14,9.19,9.22,9.19
	s9.19-4.11,9.19-9.19C9.71,787.43,5.6,783.32,0.52,783.32L0.52,783.32z M0.51,785.53c3.88,0,7.04,3.17,7.04,7.06
	c0,0.93-0.18,1.81-0.51,2.62c0.35,0.36,0.56,0.86,0.56,1.4c0,1.12-0.91,2.03-2.03,2.03c-0.38,0-0.73-0.1-1.04-0.28
	c-1.14,0.79-2.53,1.26-4.02,1.26c-3.88,0-7.06-3.15-7.06-7.04S-3.37,785.53,0.51,785.53L0.51,785.53z M0.51,786.34
	c-3.45,0-6.26,2.79-6.26,6.24c0,3.45,2.81,6.24,6.26,6.24c1.26,0,2.44-0.37,3.42-1.01c-0.25-0.34-0.4-0.75-0.4-1.2
	c0-1.12,0.91-2.03,2.03-2.03c0.29,0,0.56,0.06,0.81,0.17c0.25-0.67,0.38-1.4,0.38-2.16C6.75,789.13,3.96,786.34,0.51,786.34
	L0.51,786.34z M0.46,787.17c0.32,1.37,0.92,2.64,1.82,3.54c0.9,0.91,2.06,1.4,3.43,1.72c-1.36,0.32-2.64,0.92-3.54,1.82
	c-0.9,0.9-1.4,2.07-1.72,3.43c-0.32-1.36-0.82-2.54-1.72-3.43c-0.9-0.9-2.18-1.51-3.54-1.82c1.36-0.32,2.53-0.82,3.43-1.72
	C-0.46,789.82,0.15,788.54,0.46,787.17L0.46,787.17z M0.47,790.86c-0.87,0-1.58,0.71-1.58,1.58s0.71,1.58,1.58,1.58
	s1.58-0.71,1.58-1.58S1.34,790.86,0.47,790.86L0.47,790.86z"/>
</svg>

</template>